import styled, { css } from 'styled-components';
import { Row, Col } from 'antd';

export const Container = styled.div`
  font-family: 'Maison Neue';
  margin-top: 0;
  /* position: fixed; */
  /* left: 220px; */
  /* width: calc(100% - 220px); */
  z-index: 10;
  background-color: #f9f9f9;
  /* top: 0; */
  /* height: 100vh; */
  /* display: flex; */
  /* flex-direction: column; */
  .row_work-operations > div > div {
    padding: 16px 0 0 0;
    h3 {
      margin-left: 15px;
    }
  }
  .full-capacity {
    color: rgb(255, 88, 88);
  }
`;

export const ColWithPadding = styled(Col)`
  padding: 8px;
`;
export const MainDiv = styled.div`
  /* overflow-y: scroll; */
`;
